import { HandoffTypeMetric } from '../handoff.constants';
import { DependencyDataKeys, Result } from '../handoff-metrics.types';

const COMPLETED_VALUE = 'Completed';
const NOT_COMPLETED_VALUE = 'Not Completed';

export const wiePayerConnectionMetric: HandoffTypeMetric = {
  testCriteriaFn: function () {
    return 'Some payers should be connected';
  },
  dependencyDataKeys: [DependencyDataKeys.WIEPayerConnectionStatus],
  expectedValue: COMPLETED_VALUE,
  actualValueFn: (dependentData): string => {
    const wiePayerConnectionStatusQuery =
      dependentData[DependencyDataKeys.WIEPayerConnectionStatus];

    const err = wiePayerConnectionStatusQuery?.error;
    if (err) return (err as any).message;

    const connectionCount = wiePayerConnectionStatusQuery?.data?.connectionCount ?? 0;

    if (connectionCount > 0) {
      return COMPLETED_VALUE;
    }

    return NOT_COMPLETED_VALUE;
  },
  resultFn: function (dependentData) {
    const wiePayerConnectionStatusQuery =
      dependentData[DependencyDataKeys.WIEPayerConnectionStatus];

    const err = wiePayerConnectionStatusQuery?.error;
    if (err) return Result.Error;

    const actualValue = this.actualValueFn(dependentData);
    if (actualValue === this.expectedValue) return Result.Pass;

    return Result.Fail;
  },
  exceptions: ['Office Declined'],
};
